import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { BalanceService } from 'src/app/services/balance.service';

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.scss'],
})
export class GroupComponent implements OnInit {
  @Input() groups: any[] = [];
  @Output() emitAditional = new EventEmitter();

  constructor(public balanceSv: BalanceService) {}

  ngOnInit() {
    console.log('groups :>> ', this.groups);

    this.groups.map((item) => {
      if (!item.option.length) {
        item.hiddeGroup = true;
      }
      item.count = 0;
      item.option.map((option) => {
        // option.checked = false
      });
    });
  }

  setOption(additional, groupData, ev) {
    const checked: any[] = ev.detail.checked;
    let price = 0;
    let restPrice = 0;
    const additionalPrice = additional.promotionalPrice || additional.price;
    if (!checked) {
      restPrice += additionalPrice;
      groupData.count--;
    } else {
      price += additionalPrice;
      groupData.count++;
    }
    // const checkedAdds = additionals.filter(option => option.checked);
    const checkedGroup = this.groups.map((group) => {
      const checkedAdds = group.option.filter((option) => option.checked);
      return {
        ...group,
        checkedAdds,
      };
    });

    const options = checkedGroup.map((item) => {
      if (item.min) {
        if (item.min <= item.checkedAdds.length) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    });
    const notCanAdd = !!options.find((item: boolean) => item === true);
    this.emitAditional.emit({
      additionals: checkedGroup,
      price,
      restPrice,
      notCanAdd,
    });

    console.log('groups :>> ', this.groups);
  }

  countProduct(ev) {}
}
